    <template>
    <div>
        <van-sticky>
            <van-nav-bar v-bind="$attrs" :safe-area-inset-top="true" :title="title">
                <template #left>
                    <img v-if="leftshow" @click="push" class="leftimg" :src="lefticon" alt="">
                </template>
                <template #right>
                    <slot name="right"></slot>
                </template>
            </van-nav-bar>
        </van-sticky>
    </div>
</template>
    <script>
export default {
    props: {
        leftshow: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "",
        },
        lefticon: {
            type: String,
            default: require("@/assets/home/返回-白-Z@2x.png"),
        },
        path: {
            type: String,
            default: "",
        },
        query: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {};
    },
    created() {},
    methods: {
        push() {
            this.$router.replace({ path: this.path, query: this.query });
        },
    },
};
</script>
    <style lang='scss' scoped>
/deep/ {
    .van-nav-bar {
        padding: 3px 0;
        background: #142546;
        line-height: 56px;
        // height: 56px;
        .van-nav-bar__title {
            color: #fff;
        }
        .van-nav-bar__left {
            padding-left: 10px;
        }
    }
    .van-hairline--bottom::after {
        border-bottom-width: 0px;
    }
}
.leftimg {
    width: 32px;
    height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/navBar.vue